import { Button } from "../../components/ui/button/index.js";
import { cn } from "../../lib/utils.js";
import {
  AUTH_ENTRY_ICON_WELL_ACTIVE,
  AUTH_ENTRY_ROW,
  AUTH_ENTRY_ROW_SUBTITLE,
  AUTH_ENTRY_ROW_TITLE,
} from "../auth/entry/auth-entry-styles.js";
import { OrganizationIcon } from "./OrganizationIcon.js";

interface PendingInvitationRowProps {
  organizationName: string;
  roleLabel: string;
  actionLabel: string;
  disabled?: boolean;
  onAccept: () => void;
  testId?: string;
  actionTestId?: string;
}

/** Entry-screen row for one pending invitation with its join action. */
export function PendingInvitationRow({
  organizationName,
  roleLabel,
  actionLabel,
  disabled = false,
  onAccept,
  testId,
  actionTestId,
}: PendingInvitationRowProps): React.JSX.Element {
  return (
    <div className={cn(AUTH_ENTRY_ROW, "border-dashed border-[#c9ddd3] bg-[#fbfdfc]")} data-testid={testId}>
      <OrganizationIcon size="lg" className={cn("rounded-[10px]", AUTH_ENTRY_ICON_WELL_ACTIVE)} />
      <span className="min-w-0 flex-1 text-start">
        <span className={AUTH_ENTRY_ROW_TITLE}>
          <bdi>{organizationName}</bdi>
        </span>
        <span className={AUTH_ENTRY_ROW_SUBTITLE}>{roleLabel}</span>
      </span>
      <Button
        type="button"
        size="sm"
        className="h-9 shrink-0 rounded-[9px] border-brand-primary bg-brand-primary px-3.5 text-[13px] font-[750] text-white not-disabled:hover:border-brand-primary-hover not-disabled:hover:bg-brand-primary-hover focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-brand/35"
        disabled={disabled}
        data-testid={actionTestId}
        onClick={onAccept}
      >
        {actionLabel}
      </Button>
    </div>
  );
}
